export var ActuatorPortType;
(function (ActuatorPortType) {
    ActuatorPortType["NORMALLY_OPEN"] = "NORMALLY_OPEN";
    ActuatorPortType["NORMALLY_CLOSED"] = "NORMALLY_CLOSED";
})(ActuatorPortType || (ActuatorPortType = {}));
export const ActuatorPortTypeText = {
    NORMALLY_OPEN: 'N.O.',
    NORMALLY_CLOSED: 'N.C.',
};
export var LightSensorPort;
(function (LightSensorPort) {
    LightSensorPort["NONE"] = "NONE";
    LightSensorPort["PORT_1"] = "PORT_1";
    LightSensorPort["PORT_2"] = "PORT_2";
})(LightSensorPort || (LightSensorPort = {}));
export const LightSensorPortText = {
    NONE: 'None',
    PORT_1: 'Port 1',
    PORT_2: 'Port 2',
};
export var ActuatorCircuitStatus;
(function (ActuatorCircuitStatus) {
    ActuatorCircuitStatus["ON"] = "On";
    ActuatorCircuitStatus["OFF"] = "Off";
})(ActuatorCircuitStatus || (ActuatorCircuitStatus = {}));
export var ActuatorStateResource;
(function (ActuatorStateResource) {
    ActuatorStateResource["NONE"] = "NONE";
    ActuatorStateResource["LOCAL_USER"] = "LOCAL_USER";
    ActuatorStateResource["LOCAL_LOGIC"] = "LOGAL_LOGIC";
    ActuatorStateResource["REMOTE_LOGIC_1"] = "REMOTE_LOGIC_1";
    ActuatorStateResource["REMOTE_USER"] = "REMOTE_USER";
})(ActuatorStateResource || (ActuatorStateResource = {}));
